import React from "react"
import { ICONS } from "../../../constants/icons"

const SessionTimerControl = ({
  timer = "00:00:00",
  timerStatus = "idle",
  canToggleTimer = false,
  isTimerUpdating = false,
  onTimerToggle,
  showToggle = true,
  className = "",
}) => (
  <div
    className={`session-timer-control${
      showToggle ? "" : " session-timer-control--readonly"
    } ${className}`.trim()}
  >
    <div className="session-timer-control__time" aria-live="polite">
      {timer}
    </div>
    {showToggle ? (
      <button
        type="button"
        className="session-timer-control__toggle"
        onClick={onTimerToggle}
        disabled={!canToggleTimer || isTimerUpdating}
        aria-label={
          timerStatus === "running"
            ? "Pause session timer"
            : timerStatus === "break"
              ? "Resume session timer"
              : "Start session timer"
        }
        aria-pressed={timerStatus === "running"}
        data-pip-no-drag
      >
        <img
          src={timerStatus === "running" ? ICONS.pause : ICONS.play}
          alt=""
          width={20}
          height={20}
        />
      </button>
    ) : null}
  </div>
)

export default SessionTimerControl
